// builderPreviewHoa — which HOA default fee the lease builder's CLIENT preview
// renders with.
//
// The preview (lib/leaseRenderer via buildRenderConfig) used to render with no
// HOA default fee at all, while the Review summary above it — computed
// server-side the way the lease prints — includes it. On an HOA property the two
// totals disagreed on the same screen. The server now returns the fee it used
// (routes/leaseReviewSummary `hoaDefaultFeeCents`), and the preview renders with
// THAT value, so the HOA row and the totals match the summary.
//
// Until the first summary arrives, the property's HOA default the builder
// already loads for its HOA panel stands in (same source: property → HOA →
// default fee). Once a summary is on screen its value wins, even when it is
// null — the preview must never show an HOA fee the summary does not.

import type { LeaseReviewSummaryResponse } from './leaseDraftsClient';

export function previewHoaDefaultFeeCents(
  summary: Pick<LeaseReviewSummaryResponse, 'hoaDefaultFeeCents'> | null,
  propertyHoaDefaultFeeCents: number | null | undefined,
): number | null {
  if (summary) return summary.hoaDefaultFeeCents ?? null;
  return propertyHoaDefaultFeeCents ?? null;
}
